import * as api from './../../../api/links'
import {
  GENERATE_LINK,
  GET_LINK_BY_ID,
  GET_LINKS,
  DELETE_LINK,
} from './../../actionTypes'
import { showLoader } from '../loader/showLoader'
import { hideLoader } from './../loader/hideLoader'
import { setAlert } from './../alert/setAlert'
import { verifyToken } from './../auth/verifyToken'

export const generateLink =
  ({ link }, headers, clear) =>
  async (dispatch) => {
    try {
      dispatch(showLoader())
      dispatch(verifyToken())
      const { data } = await api.generateLink({ originLink: link }, headers)
      dispatch(setAlert(true, 'success', data.message, 2000))
      dispatch({ type: GENERATE_LINK, payload: data.link })
      clear()
      dispatch(hideLoader())
    } catch (e) {
      clear()
      const error = e.response.data.errors.map((e) => e.msg)
      dispatch(setAlert(true, 'error', error))
      dispatch(hideLoader())
    }
  }

export const getLinkById = (linkId, headers) => async (dispatch) => {
  try {
    dispatch(showLoader())
    const { data } = await api.getLinkById(linkId, headers)
    dispatch({ type: GET_LINK_BY_ID, payload: data.link })
    dispatch(hideLoader())
  } catch (e) {
    dispatch(hideLoader())
    dispatch(setAlert(true, 'error', e.response.data.message))
  }
}

export const getLinks = (headers) => async (dispatch) => {
  try {
    dispatch(showLoader())
    dispatch(verifyToken())
    const { data } = await api.getLinks(headers)
    dispatch({ type: GET_LINKS, payload: data })
    dispatch(hideLoader())
  } catch (error) {
    dispatch(hideLoader())
    console.log(error)
  }
}

export const deleteLink = (id) => async (dispatch) => {
  try {
    const { data } = await api.deleteLink(id)
    dispatch(setAlert(true, 'success', data.message, 2000))
    dispatch({ type: DELETE_LINK, payload: id })
  } catch (error) {
    console.log(error)
  }
}
